export const imageUpload = {
	addImage: "Añadir imagen",
	validating: "Validando imagen...",
	verifyingDimensions: "Verificando dimensiones y formato...",
	removeImage: "Eliminar imagen cargada",
	formatInfo: "JPG o PNG hasta {{maxSize}}MB y {{width}}x{{height}}px.",
	ariaLabel: {
		fileInput: "Campo de entrada para subir imagen",
		uploadedImage: "Imagen del producto cargada",
		uploadHeading: "Encabezado de carga",
	},
	errors: {
		fileTooLarge: "Archivo muy grande. Tamaño máximo: {{maxSize}}MB",
		fileInvalidType: "Tipo de archivo inválido. Usa solo JPG o PNG.",
		fileDimensionsTooLarge: "Dimensiones muy grandes. Máximo: {{width}}x{{height}}px",
		generalError: "Error al cargar la imagen",
		validationError: "Error al validar imagen",
		invalidFile: "Archivo inválido",
	},
};
